import { formatCurrency, formatDateTime, formatDecimalUnit } from '@/common/utils/formatters'
import { ConsumptionData, ConsumptionTableItem } from '@/features/tmaisUsers/types/tmaisUserConsumptions.type'
import { BoxesIcon } from 'lucide-react'

export class ConsumptionDataTransformer {
  static tableTransformer() {
    return (consumptions: ConsumptionData[]): ConsumptionTableItem[] => {
      return consumptions.map((consumption) => ({
        consumed_at: consumption.consumed_at ? formatDateTime(new Date(consumption.consumed_at)) : '',
        products: (
          <div className="flex items-center gap-x-1">
            <BoxesIcon strokeWidth={1} className="size-6" />

            <div className="flex flex-col">
              {consumption.line_items.map((item) => (
                <span key={item.id}>
                  {item.product.display_name} - {formatDecimalUnit(item.quantity, item.product.unit_for_quantity)} -{' '}
                  {formatCurrency(Number(item.total_amount))}
                </span>
              ))}
            </div>
          </div>
        ),
        total_amount: formatCurrency(Number(consumption.total_amount_from_valid_items ?? 0)),
      }))
    }
  }
}
